import React, { useCallback, useEffect, useRef, useState } from "react"
import swal from 'sweetalert';
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter } from 'react-router-dom';
import { modalsSelector } from "../../selectors";
import { updateMarkedCodesOrder } from "../../action/orders";
import { styles } from "../goods/styles";
import Loader from "../../components/utils/Loader";
import { acceptMarkingCode, setBeginMarkingCodeValidation } from "../../action/cassa";

const MarkedGoodsModal = () => {
    const loadingUpdate = useSelector((state) => state.loaders.updateMarkedCodes)
    const errorUpdate = useSelector((state) => state.errors.updateMarkedCodes)
    const props = useSelector(modalsSelector).markedGoods;

    const keyBuffer = useRef([]);
    const markedCodesRef = useRef({});
    const lastKeyTime = useRef(0);
    const inputStartTime = useRef(0);
    const isScanningActive = useRef(true);

    const [countGood, setCountGood] = useState(0);
    const [errorMark, setErrorMark] = useState(null);
    const [ loading, setLoading ] = useState(false);

    const dispatch = useDispatch();

    const keyCodeToCharMap = {
        '48': '0', '49': '1', '50': '2', '51': '3', '52': '4',
        '53': '5', '54': '6', '55': '7', '56': '8', '57': '9',
        '189': '-', '187': '=', '219': '[', '221': ']', '186': ';',
        '222': "'", '188': ',', '190': '.', '191': '/', '192': '`',
        '16-49': '!', '16-50': '@', '16-51': '#', '16-52': '$', '16-53': '%',
        '16-54': '^', '16-55': '&', '16-56': '*', '16-57': '(', '16-48': ')',
        '16-189': '_', '16-187': '+', '16-219': '{', '16-221': '}', '16-186': ':',
        '16-222': '"', '16-188': '<', '16-190': '>', '16-191': '?', '16-192': '~',
        '119': '\u001d'
    };

    for (let i = 65; i <= 90; i++) {
        keyCodeToCharMap[i.toString()] = String.fromCharCode(i + 32);
        keyCodeToCharMap[`16-${i}`] = String.fromCharCode(i);
    };

    const isScan = (currentTime) => {
        if (keyBuffer.current.length === 0) {
            inputStartTime.current = currentTime;
            return true;
        }
        
        const timeLastChar = currentTime - lastKeyTime.current;
        const avgTimeChar = (currentTime - inputStartTime.current) / keyBuffer.current.length;
        
        return timeLastChar < 50 && avgTimeChar < 50;
    };

    const nextGood = (ignore, code) => {
        const id = props.markedGoods[countGood].id;
        const scannedCode = keyBuffer.current.join('');
        // eslint-disable-next-line no-control-regex
        const correctedCode = code ? code : btoa(scannedCode.replace(/\u001d/g, '\u001d'));

        const updatedMarkedCodes = {
            ...markedCodesRef.current,
            [id]: [...(markedCodesRef.current[id] || []), correctedCode]
        };

        markedCodesRef.current = updatedMarkedCodes;

        keyBuffer.current = [];
        lastKeyTime.current = 0;
        inputStartTime.current = 0;
        
        if (countGood !== props.markedGoods.length - 1) {
            setCountGood(prevCount => prevCount + 1);
            if (!ignore) {
                swal({
                    title: "Успех!",
                    text: "Товар успешно отсканирован",
                    icon: "success",
                    timer: 1000,
                    buttons: false,
                });
            }
        } else {
            onCloseSuccess(true);
        }
    }

    const onCloseSuccess = async (fine) => {
        const result = await dispatch(updateMarkedCodesOrder(props.id, markedCodesRef.current, props.isArchive, props.changeStatus && fine));
        if (!result) return null;

        const text = fine ? 'Все коды успешно отсканированы' : `Отсканировано ${countGood} кодов из ${props.markedGoods.length}`
        return swal({
            title: "Сканирование заверешено",
            text,
            icon: "success",
            timer: 5000,
            button: "Ок",
        }).then(() => onClose());
    }

    const sendRequest = async (code) => {
        if (!code) return setErrorMark({ error_message: 'Код не считан' });
        setLoading(true);
        try {
            const response = await dispatch(setBeginMarkingCodeValidation(props.pointId, code, true));
            if (response && response.error) {
                setLoading(false);
                return setErrorMark(response.error);
            }
            setLoading(false);
            nextGood(false, code);
            return true;
        } catch (error) {
            if (error) {
                setErrorMark(error);
            } else {
                setErrorMark({error_message: 'Неизвестная ошибка. Повторите попытку.'});
            }
            
            keyBuffer.current = [];
            lastKeyTime.current = 0;
            inputStartTime.current = 0;
            setLoading(false);
            return false;
        }
    }

    const handleGlobalKeyDown = useCallback((event) => {
        if (!isScanningActive.current || loadingUpdate || loading || event.repeat) return;
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        
        const currentTime = Date.now();
        
        if (!isScan(currentTime) && keyBuffer.current.length > 0) {
            keyBuffer.current = [];
            swal({
                title: "Обнаружен ручной ввод",
                text: "Пожалуйста, используйте сканер штрих-кодов",
                icon: "warning",
                timer: 2000,
                buttons: false,
            });
            return;
        }
        
        const keyCode = event.keyCode;
        const shiftKey = event.shiftKey;
        const key = shiftKey ? `16-${keyCode}` : keyCode.toString();
        
        let char = keyCodeToCharMap[key];
        if (!char && shiftKey) {
            char = keyCodeToCharMap[keyCode.toString()];
        }
        
        if (char) {
            event.preventDefault();
            event.stopPropagation();
            
            keyBuffer.current.push(char);
            lastKeyTime.current = currentTime;
        }
        
        if (keyCode === 13) {
            event.preventDefault();
            event.stopPropagation();

            if (keyBuffer.current.length < 5) {
                swal({
                    title: "Неверный код",
                    text: "Считанный код слишком короткий",
                    icon: "warning",
                    timer: 2000,
                    buttons: false,
                });
                keyBuffer.current = [];
                lastKeyTime.current = 0;
                inputStartTime.current = 0;
                return;
            }

            setTimeout(() => {
                const scannedCode = keyBuffer.current.join('');
                // eslint-disable-next-line no-control-regex
                const correctedCode = scannedCode.replace(/\u001d/g, '\u001d')
                sendRequest(btoa(correctedCode));
            }, 50);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keyCodeToCharMap, loadingUpdate]);

    useEffect(() => {
        isScanningActive.current = true;
        
        const handleKeyDown = (event) => {
            handleGlobalKeyDown(event);
        };
        
        document.addEventListener('keydown', handleKeyDown, true);
        
        return () => {
            isScanningActive.current = false;
            document.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [handleGlobalKeyDown]);

    useEffect(() => {
        if (errorMark) {
            const { code, error_message, message, description} = errorMark;
            let text = '';
            if (code) text += String(code);
            if (message) text += `. ${message}`;
            if (error_message) text +=` ${error_message}`;
            if (description) text += ` ${description}`;
            swal({
                title: "Ошибка верификации кода маркировки",
                text: text,
                icon: "warning",
                dangerMode: true,
                buttons: ["Повторить сканирование", "Игнорировать"],
            }).then(async (ignore) => {
                if (ignore) {
                    // eslint-disable-next-line no-control-regex
                    const correctedCode = code.replace(/\u001d/g, '\u001d')
                    const response = await dispatch(acceptMarkingCode(btoa(correctedCode), props.pointId));
                    if (response && response.error) {
                        setErrorMark(response.error);
                    } else if (response && !response.error) {
                        nextGood(true);
                    }
                    if (!response) setErrorMark({error_message: 'Неизвестная ошибка. Повторите попытку.'});
                }
                setErrorMark(null);
                keyBuffer.current = [];
                lastKeyTime.current = 0;
                inputStartTime.current = 0;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMark]);
    
    useEffect(() => {
        if (errorUpdate) swal({
            title: "Ошибка сохранения данных",
            text: 'Повторите попытку или обратитесь к администратору',
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Повторить"],
        }).then((repeat) => {
            if (repeat) {                
                dispatch(updateMarkedCodesOrder(props.id, markedCodesRef.current, props.isArchive))
            } else {
                onClose();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorUpdate])

    const onClose = () => {
        isScanningActive.current = false;
        dispatch(setActiveModalAction({ field: 'markedGoods', value: null }));
    };

    const renderGoodTitle = (good) => {
        if (good.categoryName) {
            if (good.categoryName.toLowerCase() === 'пицца') {
                return `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`                
            }
            return good.data.title
        }
        const category = props.categories.find(o => o.id === good.category);
        if (!category) return good.data.title;
        if (category.title.toLowerCase() === 'пицца') {
            return `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`;
        }
        return good.data.title
    }

    if (loadingUpdate) return(
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                          <div>
                            <h5 className="modal-title"> Маркированный товар </h5>
                          </div>
                        </div>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                            <div style={styles.tableLoading}><Loader text='Сохранение данных'/></div>
                        </div>
                        <div className="modal-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return(
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                          <div>
                            <h5 className="modal-title"> Маркированный товар </h5>
                          </div>
                            {!loadingUpdate && !loading && <button onClick={() => countGood > 0 ? onCloseSuccess(false) : onClose()} type="button" className="close"></button>}
                        </div>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                            {loadingUpdate || loading ? 
                            <div style={styles.tableLoading}><Loader text='Сохранение данных'/></div>
                            :
                            <>
                                <div style={{ color: 'black', fontSize: '1.3rem' }}>Необходимо отсканировать товар:</div>
                                <div style={{ color: 'black', fontSize: '1.5rem' }}>
                                    {`${renderGoodTitle(props.markedGoods[countGood])}`}
                                </div>
                                <div style={{ marginTop: '20px', color: '#666', fontSize: '1rem' }}>
                                    Готов к сканированию...
                                </div>
                            </>
                            }                            
                        </div>
                        <div className="modal-footer">
                        {!loadingUpdate && !loading && <button type="button" className="btn btn-secondary" onClick={() => countGood > 0 ? onCloseSuccess(false) : onClose()}>Отмена</button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(MarkedGoodsModal);